module.exports = __webpack_public_path__ + "static/media/food.e6363f29.jpg";